import { usePathname, useSearchParams } from "next/navigation";

import toggleURLSearchParamValue from "@/utils/toggleURLSearchParamValue";

import FilterChipLink from "@/components/FilterChipLink";

import { FULFILLMENT_METHODS } from "../FulfillmentFilters/FulfillmentFilters";

const AppliedFulfillmentChips = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const targetURLSearchParams = new URLSearchParams(searchParams?.toString());
  // * Remove pagination params when clicking fulfillment filter link.
  targetURLSearchParams.delete("page");

  let appliedFulfillments: string[] = [];
  if (searchParams?.getAll("fulfillment").length) {
    appliedFulfillments = searchParams.getAll("fulfillment");
  } else if (searchParams?.getAll("fulfillment[]").length) {
    appliedFulfillments = searchParams.getAll("fulfillment[]");
  }

  return appliedFulfillments.map((fulfillment) => {
    const fulfillmentMethod = FULFILLMENT_METHODS.find(
      (method) => method.value === fulfillment,
    );

    if (fulfillmentMethod) {
      return (
        <FilterChipLink
          key={`fulfillment_chip_${fulfillmentMethod.name}`}
          href={{
            pathname,
            query: toggleURLSearchParamValue(
              targetURLSearchParams,
              "fulfillment",
              fulfillmentMethod.value,
              { forceArray: true },
            ).toString(),
          }}
        >
          {fulfillmentMethod.name}
        </FilterChipLink>
      );
    }

    return (
      <FilterChipLink
        key={`fulfillment_chip_${fulfillment}`}
        href={{
          pathname,
          query: toggleURLSearchParamValue(
            targetURLSearchParams,
            "fulfillment",
            fulfillment,
            { forceArray: true },
          ).toString(),
        }}
      >
        {fulfillment}
      </FilterChipLink>
    );
  });
};

export default AppliedFulfillmentChips;
